import LinearProgress from '@mui/material/LinearProgress';
import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router';
import { Actions } from '../../store/actions/facilityActions';
import { AddButton } from '../../styledComponents/GlobalStyle';
import { checkReportingYearEndAndIndustry } from '../utils/GlobalFunctions';
import DeleteFacilityModal from './DeleteFacilityModal';
import FacilityRow from './FacilityRow';
import UploadFacilityData from './UploadFacilityData';
import { NoPermissions } from '../Common/ReusableComponents/Reusable';

const FacilityTable = ({
  list,
  getFacilityMetrics,
  currentOrganisation,
  showFacilityImportModal,
  branding,
  showLoader,
  addFacilityIssue,
  loading,
  canManageOrg,
  canView,
}) => {
  const { body } = branding.fonts?.[0].font || {};
  const history = useHistory();

  if (showLoader && !list.length) {
    return <LinearProgress color='inherit' />;
  }

  return (
    <>
      {!canView && <NoPermissions />}
      {canView && (
        <div className='row' style={{ fontFamily: body }}>
          <div className='col-lg-12'>
            <section className='panel'>
              <header className='panel-heading'>Your Facilities</header>
              <div className='panel-body'>
                {showLoader ? (
                  <LinearProgress sx={{ marginTop: '3vh' }} color='inherit' />
                ) : (
                  <table id='your-facilities-table' className='table table-hover general-table'>
                    <thead>
                      <tr>
                        <th>Facility</th>
                        <th>Facility Type</th>
                        <th>Primary</th>
                        <th>Post code</th>
                        <th>External ID</th>
                        <th>Facility m2</th>
                        <th>Metrics</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {list &&
                        Array.isArray(list) &&
                        list.map((facilityDetails, index) => <FacilityRow key={index} facilityDetails={facilityDetails} />)}
                      {canManageOrg && (
                        <tr>
                          <td>
                            <AddButton
                              id='add-facility-button'
                              onClick={() => {
                                addFacilityIssue
                                  ? history.push(`/organisations/${currentOrganisation}`)
                                  : history.push('/facilities/new');
                              }}
                              className='btn btn-success'>
                              {addFacilityIssue ? `${addFacilityIssue} to add a facility` : 'Add a Facility'}
                            </AddButton>
                          </td>
                          <td>
                            <AddButton
                              className='btn btn-success'
                              onClick={() => showFacilityImportModal(true)}
                              bordercolor='true'
                              style={{ marginRight: 15 }}>
                              <i className='fa fa-cloud-upload' /> Import Facilities
                            </AddButton>
                          </td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                )}
              </div>
            </section>
          </div>

          <UploadFacilityData />
          <DeleteFacilityModal />
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  const orgDetails = state?.organisation?.details;

  const addFacilityIssue = checkReportingYearEndAndIndustry(orgDetails);

  const facilityPermissions = Object.keys(state?.organisation?.permissions?.facilities || {})
    ?.filter((key) => key !== '*')
    ?.reduce((acc, key) => {
      acc[key] = state?.organisation?.permissions?.facilities[key];
      return acc;
    }, {});
  const specificFacilityPermissions = Object.keys(facilityPermissions).some((facility) => {
    return facilityPermissions[facility]?.view;
  });

  return {
    list: _.sortBy(_.uniqBy(state.facility?.list, 'id'), ['name']),
    currentOrganisation: state.currentOrganisation,
    branding: state.branding,
    showLoader: state?.showLoader,
    addFacilityIssue,
    canManageOrg: !!state?.organisation?.permissions?.organisation?.manage,
    canView: state?.organisation?.permissions?.facilities?.['*']?.view || specificFacilityPermissions,
  };
};

const mapDispatchToProps = (dispatch) => ({
  showFacilityImportModal: (status) => dispatch(Actions.showFacilityImportModal(status)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FacilityTable);
